<template>
  <div class="infoBox" :class="type">
    <div class="infoBox--content">
      <span
        v-if="withIcon"
        class="icon infoBox--icon"
        :class="iconClass"
      />
      <slot />
    </div>
  </div>
</template>

<script src="./InfoBox.js"></script>
